import { render, staticRenderFns } from "./allBuildings.vue?vue&type=template&id=63869d55&scoped=true&"
import script from "./allBuildings.vue?vue&type=script&lang=js&"
export * from "./allBuildings.vue?vue&type=script&lang=js&"
import style0 from "./allBuildings.vue?vue&type=style&index=0&id=63869d55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63869d55",
  null
  
)

export default component.exports